import React from 'react';
import { FormAccordion, FormAccordionItem } from 'src/UI/dynamicUI/layout/DynamicEntitySection';
import { Grid } from '@mantine/core';
import { ProductFormComponentProps } from 'src/financial/financial-data/financial-item/forms/common/FinancialFormHelpers';
import { GridPair } from 'src/financial/financial-data/financial-item/forms/common/GridPair';
import { FinancialFormField } from 'src/financial/financial-data/financial-item/forms/common/FinancialFormField';
import { GenericFinancialItemFormWrapper } from 'src/financial/financial-data/financial-item/forms/GenericFinancialItemFormWrapper';
const COLLECTIBLE_PRODUCT = 'Collectible';

export function Collectible(props: ProductFormComponentProps) {
  return (
    <GenericFinancialItemFormWrapper
      title={'Assets > Collectible'}
      {...props}
      product={COLLECTIBLE_PRODUCT}
    >
      <FormAccordion defaultValue={['summary', 'cover', 'term', 'premium']}>
        <FormAccordionItem value="summary" label="Summary">
          <Grid>
            <GridPair
              first={<FinancialFormField field="type" product={COLLECTIBLE_PRODUCT} />}
              second={<FinancialFormField field="description" product={COLLECTIBLE_PRODUCT} />}
            />
            <GridPair
              isHighlighted
              first={<FinancialFormField field="value" product={COLLECTIBLE_PRODUCT} />}
              second={<FinancialFormField field="value_date" product={COLLECTIBLE_PRODUCT} />}
            />
            <GridPair
              fullWidth
              first={<FinancialFormField field="notes" product={COLLECTIBLE_PRODUCT} />}
            />
          </Grid>
        </FormAccordionItem>
      </FormAccordion>
    </GenericFinancialItemFormWrapper>
  );
}
